import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UpdateClientProfileRequest } from '../../happypaws-shared/src/User/models/UpdateClientProfileRequest';
import { api } from '../../services/api';

export const useUpdateClientProfile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: UpdateClientProfileRequest) => {
      const response = await api.patch('/clients/profile', data);
      return response.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['clientProfile'] });
    },
  });
};
